import './StoreNoteGrid.scss'
import DataGrid, { Column, Item, LoadPanel, Paging, Scrolling, SearchPanel, Toolbar } from 'devextreme-react/data-grid';
import { encode } from 'html-entities';
import { KindOfOrder } from '../../../../types/enums';
import { useGetStoreNotes } from '../api/get-store-notes';
import { Link } from 'react-router-dom';
import { showErrorMessage } from '../../../../utils/messages';
import Button from 'devextreme-react/button';
import { useState } from 'react';
import { useAuth } from '../../../../contexts/auth';
import { LoadPagePanel } from '../../../../components';
import { useMarkStoreNoteAsRead } from '../api/mark-store-note-as-read';
import { AddNoteParams } from '../../../common/notes/types/AddNoteParams';
import AddNotePopup from '../../../common/notes/components/AddNotePopup';

export default function StoreNoteGrid(props: { kindOfOrder: KindOfOrder }) {

	const storeNotes = useGetStoreNotes(props.kindOfOrder);

	const markNoteAsRead = useMarkStoreNoteAsRead(
		() => storeNotes.refetch(),
		(error) => showErrorMessage(error));

	const [isPopupVisible, setPopupVisibility] = useState(false);
	const [noteParams, setNoteParams] = useState<AddNoteParams>();

	const { user } = useAuth();

	return (
		<>
			{
				storeNotes.data?.length > 0 ?
					<DataGrid
						className={'dx-card wide-card store-notes-grid'}
						dataSource={storeNotes.data}
						allowColumnReordering={true}
						allowColumnResizing={true}
						showBorders={true}
						showColumnLines={true}
						columnAutoWidth={true}
						keyExpr={'noteID'}
						height="68vh"
					>
						<LoadPanel enabled={false} />
						<Paging enabled={false}></Paging>
						<Scrolling rowRenderingMode='virtual'></Scrolling>
						<SearchPanel visible={true} />

						<Toolbar visible={storeNotes.data?.length > 0}>
							<Item location='before' name='searchPanel'>
							</Item>
							<Item location='after'>
								<Button
									text="Mark All As Read"
									icon="Inscyth-Order-Material"
									onClick={() => markNoteAsRead.mutate({ kindOfOrder: props.kindOfOrder })}>
								</Button>
							</Item>
						</Toolbar>

						<Column
							dataField={'orderNumber'}
							caption={'Order #'}
							dataType="string"
							cellRender={(cell: any) => {
								if (props.kindOfOrder === KindOfOrder.RetailOrder) {
									return <Link to={`/cfi/retail-order/${cell.data.orderID}`}>
										{cell.data.orderNumber}
									</Link>;
								}
								else if (props.kindOfOrder === KindOfOrder.WorkOrder) {
									return <Link to={`/cfi/work-order/${cell.data.orderID}`}>
										{cell.data.orderNumber}
									</Link>;
								}
								else if (props.kindOfOrder === KindOfOrder.Estimate) {
									return <Link to={`/cfi/estimate/${cell.data.orderID}`}>
										{cell.data.orderNumber}
									</Link>;
								}

								return <>{cell.data.orderNumber}</>;
							}}
						/>
						<Column
							dataField={'customerName'}
							caption={'Customer Name'}
							dataType="string"
						/>
						<Column
							dataField={'createdBy'}
							caption={'Creator'}
							dataType="string"
						/>
						<Column
							dataField={'createdOn'}
							caption={'Created On'}
							dataType="datetime"
						/>
						<Column
							dataField={'storeNumber'}
							caption={'Store #'}
							dataType="string"
						/>
						<Column
							dataField={'noteText'}
							caption={'Message'}
							dataType="string"
							cssClass={'multi-line'}
							encodeHtml={false}
							calculateDisplayValue={(rowData) => {
								return encode(rowData.noteText).replaceAll('\r\n', '<br/>');
							}}
						/>
						<Column
							width={200}
							cellRender={(row: any) => {
								return <>
									<a onClick={(e) => {
										e.preventDefault();
										markNoteAsRead.mutate({ noteID: row.data.noteID });
									}}>
										Mark as read
									</a>
									<Button
										text="Reply"
										className='reply-button' onClick={() => {
											setNoteParams({
												showNoteType: false,
												emailSubject: `${row.data.orderNumber} - ${row.data.customerName.trim()} - Project # ${row.data.projectNumber}`,
												companyIDs: [row.data.dealerCompanyID, user?.companyId],
												kindOfOrder: props.kindOfOrder,
												orderID: row.data.orderID,
												onNoteAdded: () => { markNoteAsRead.mutate({ noteID: row.data.noteID }); }
											});
											setPopupVisibility(true);
										}}>
									</Button>
								</>;
							}}
						/>
					</DataGrid>
					:
					<div>
						{!storeNotes.isLoading && 'There are no more messages to read at the moment.'}
					</div>
			}
			{
				isPopupVisible &&
				<AddNotePopup
					caption="Reply to Note"
					params={noteParams!}
					onHidePopup={() => setPopupVisibility(false)} />
			}

			<LoadPagePanel visible={storeNotes.isLoading || storeNotes.isRefetching || markNoteAsRead.isLoading} />
		</>
	)
}
